module.exports = __webpack_public_path__ + "img/7_142.4942e944.png";